<h1>Store Management</h1>

<form *ngIf="store$ | async as T; else loading" [formGroup]="formGroup" novalidate>
    <mat-card appearance="outlined">
        <mat-card-content fxLayout="column">

            <h2>{{formGroup.controls.Detail.controls.StoreName.value == '' ? "Store" : formGroup.controls.Detail.controls.StoreName.value}}</h2>

            <div formGroupName="Detail" fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Store Name</mat-label>
                    <input matInput type="text" formControlName="StoreName" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.StoreName.hasError('required')">
                        Store Name is required
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.StoreName.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.StoreName.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.StoreName.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.StoreName.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.StoreName.errors!['maxlength']['requiredLength'] + '.'}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Address 1</mat-label>
                    <input matInput type="text" formControlName="Address1" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.Address1.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.Address1.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.Address1.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.Address1.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.Address1.errors!['maxlength']['requiredLength'] + '.'}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Address 2</mat-label>
                    <input matInput type="text" formControlName="Address2" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.Address2.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.Address2.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.Address2.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.Address2.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.Address2.errors!['maxlength']['requiredLength'] + '.'}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="City" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.City.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.City.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.City.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.City.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.City.errors!['maxlength']['requiredLength'] + '.'}}
                        {{formGroup.controls.Detail.controls.City.errors!['pattern'] && 'City may only contain alphanumeric characters.'}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>State</mat-label>
                    <input matInput type="text" formControlName="State" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.State.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.State.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.State.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.State.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.State.errors!['maxlength']['requiredLength'] + '.'}}
                        {{formGroup.controls.Detail.controls.State.errors!['pattern'] && 'State may only contain alphanumeric characters. '}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Postal Code</mat-label>
                    <input matInput type="text" formControlName="PostalCode" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.PostalCode.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.PostalCode.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.PostalCode.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.PostalCode.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.PostalCode.errors!['maxlength']['requiredLength'] + '.'}}
                        {{formGroup.controls.Detail.controls.PostalCode.errors!['pattern'] && 'Postal Code may only contain alphanumeric characters. '}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32">
                    <mat-label>Banner</mat-label>
                    <mat-select formControlName="BannerId">
                        <mat-option [value]=""></mat-option>
                        <mat-option *ngFor="let banner of banners$" [value]="banner.Id">
                            {{banner.BannerName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32">
                    <mat-label>Division</mat-label>
                    <mat-select formControlName="DivisionId">
                        <mat-option [value]=""></mat-option>
                        <mat-option *ngFor="let division of divisions$" [value]="division.Id">
                            {{division.DivisionName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="storeId != '0'" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Id</mat-label>
                    <input matInput formControlName="Id" readonly>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="32" fxFlex.lt-md="auto">
                    <mat-label>Client Key</mat-label>
                    <input matInput type="text" formControlName="ClientKey" />
                    <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.hasError('required')">
                        Client key is required
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.hasError('invalid')">
                        {{formGroup.controls.Detail.controls.ClientKey.getError('invalid')}}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.status=='INVALID'">
                        {{formGroup.controls.Detail.controls.ClientKey.errors!['maxlength'] && 'Maximum length can be' + formGroup.controls.Detail.controls.ClientKey.errors!['maxlength']['requiredLength'] + '.'}}
                    </mat-error>
                </mat-form-field>

            </div>

            <app-store-attributes-edit-section
              [categories$]="storeAttributesCategories$"
              [attributeFieldsGroup]="getAttributeFieldsGroup()">
            </app-store-attributes-edit-section>
        </mat-card-content>
        <mat-card-actions>
            <div fxLayout="row" [fxLayoutAlign]="storeId != '0'?'space-between':'end'" class="mat-card-actions-details">
                <button mat-raised-button type="button" color="warn" (click)="deleteRecord()" *ngIf="storeId != '0'">
                    Delete
                </button>
                <div fxLayout="row" fxLayoutGap="16px">
                    <button mat-stroked-button type="reset" (click)="cancel()">
                        Cancel
                    </button>
                    <button mat-raised-button type="button" (click)="save() " [disabled]="formGroup.invalid"
                        color="accent">
                        Save
                    </button>
                </div>
            </div>
        </mat-card-actions>
    </mat-card>
</form>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>